(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function syncSpecTableDetails() {
    document.querySelectorAll('.spec-table__card').forEach(function (details) {
      if (DESKTOP_MQ.matches) {
        details.open = true;
        return;
      }

      if (details.dataset.openByDefault === 'true') {
        details.open = true;
      } else {
        details.open = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSpecTableDetails);
  } else {
    syncSpecTableDetails();
  }

  DESKTOP_MQ.addEventListener('change', syncSpecTableDetails);
})();
